// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"edeb011c","977":"ee531830"}[chunkId] + ".chunk.js";
};